"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var en_US_1 = __importDefault(require("../../locale/en_US"));
/**
 * Button to upload / import geodata file.
 */
var UploadButton = /** @class */ (function (_super) {
    __extends(UploadButton, _super);
    function UploadButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadButton.prototype.render = function () {
        var _a = this.props, onUpload = _a.onUpload, locale = _a.locale;
        return (React.createElement(antd_1.Upload, { name: "file", action: "memory", customRequest: onUpload },
            React.createElement(antd_1.Button, null,
                React.createElement(antd_1.Icon, { type: "upload" }),
                " ",
                locale.upload)));
    };
    UploadButton.defaultProps = {
        locale: en_US_1.default.GsUploadButton
    };
    return UploadButton;
}(React.Component));
exports.UploadButton = UploadButton;
exports.default = UploadButton;
//# sourceMappingURL=UploadButton.js.map